export default function BetterOnDesktop({ pageName }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4 p-8 text-center bg-n-25">
      <div className="w-14 h-14 rounded-2xl bg-white border border-n-200 flex items-center justify-center shadow-1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="text-n-400" aria-hidden="true">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      </div>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-n-800">
          {pageName ? `${pageName} works better on desktop` : 'Better on desktop'}
        </p>
        <p className="text-sm text-n-500 max-w-[260px]">
          Open this page on a laptop or desktop for the full experience.
        </p>
      </div>
    </div>
  );
}
